import {
  LOGIN_LOADING,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  SIDEBAR_COLLAPSE,
  SET_SHOP_INFO,
  SET_PAYMENT_METHOD_INFO,
  SET_MERCHANT_INFO,
  SET_CAMPAIGN_INFO,
  SET_DRIVER_INFO,
  SET_CORPORATE_INFO,
  SET_USER_INFO,
  LOGOUT,
  SET_FEEDBACK_INFO,
  SET_BRAND_INFO,
  SET_MALL_INFO,
} from "./authType";

const initialState = {
  name: "",
  email: "",
  profilePicture: "",
  role: "",
  exp: null,
  error: false,
  success: false,
  loading: false,
  type: null,
  token: null,
  sidebarCollapse: false,
  campaignInfo: {
    id: "",
    name: "",
    campaignType: "",
    minimumDiscount: "",
    minimumDiscountType: "",
    banner: "",
    bannerWeb: "",
    status: null,
    startAt: null,
    endAt: null,
  },
  merchantInfo: {
    id: "",
    name: "",
    balance: "",
    profilePicture: "",
    mobileNumber: "",
    email: "",
    state: "",
    status: "",
    merchantId: "",
  },
  shopInfo: {
    id: "",
    name: "",
    type: "",
    mobileNumber: "",
    rating: null,
    logo: "",
    banner: "",
    status: "",
    hubId: "",
    deleted: "",
  },
  driverInfo: {
    driverId: "",
    image: "",
    name: "",
    rating: null,
    balance: "",
    mobileNumber: "",
    status: "",
  },
  customerInfo: {
    fullName: "",
    profilePicture: "",
    balance: "",
    rating: null,
    numberOfRating: null,
    mobileNumber: "",
    status: "",
    id: "",
  },
  corporateInfo: {
    id: "",
    ownerId: "",
    image: "",
    name: "",
    balance: "",
    isActive: "",
  },
  brandInfo: {
    id: "",
    name: "",
    type: "",
    logo: "",
    bannerImage: "",
    sellCount: "",
    status: null,
  },
  mallInfo: {
    id: "",
    name: "",
    address: "",
  },
  feedbackInfo: {
    customerName: "",
    customerImage: "",
    customerContact: "",
    id: "",
    customerType: "",
  },
};

const authRedcer = (
  state = initialState,
  action = { type: "", payload: {} }
) => {
  switch (action.type) {
    case LOGIN_REQUEST: {
      state.loading = true;
      return state;
    }

    case LOGIN_SUCCESS: {
      state = { ...state, ...action.payload };
      state.loading = false;
      return state;
    }

    case LOGIN_LOADING: {
      return state;
    }

    case SIDEBAR_COLLAPSE: {
      state = { ...state, ...action.payload };
      return state;
    }

    case SET_SHOP_INFO: {
      state = { ...state, ...action.payload };
      state.loading = false;
      return state;
    }
    case SET_PAYMENT_METHOD_INFO: {
      state = { ...state, ...action.payload };
      state.loading = false;
      return state;
    }
    case SET_MERCHANT_INFO: {
      state = { ...state, ...action.payload };
      state.loading = false;
      return state;
    }

    case SET_CAMPAIGN_INFO: {
      state = { ...state, ...action.payload };
      state.loading = false;
      return state;
    }

    case SET_DRIVER_INFO: {
      state = { ...state, ...action.payload };
      state.loading = false;
      return state;
    }
    case SET_CORPORATE_INFO: {
      state = { ...state, ...action.payload };
      state.loading = false;
      return state;
    }
    case SET_USER_INFO: {
      state = { ...state, ...action.payload };
      state.loading = false;
      return state;
    }

    case SET_BRAND_INFO: {
      state = { ...state, ...action.payload };
      state.loading = false;
      return state;
    }
    case SET_MALL_INFO: {
      state = { ...state, ...action.payload };
      state.loading = false;
      return state;
    }
    case SET_FEEDBACK_INFO: {
      state = { ...state, ...action.payload };
      state.loading = false;
      return state;
    }
    case LOGOUT: {
      state = { ...state, token: null, ...action.payload };
      return state;
    }

    default: {
      state.loading = false;
      return state;
    }
  }
};

export default authRedcer;
